/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Networks_List_DescriptionInputs */

const fr_networks_list_description = /** @type {(inputs: Networks_List_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un réseau pour consulter ses véhicules et lignes.`)
};

const en_networks_list_description = /** @type {(inputs: Networks_List_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a network to view its vehicles and lines.`)
};

/**
* | output |
* | --- |
* | "Select a network to view its vehicles and lines." |
*
* @param {Networks_List_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const networks_list_description = /** @type {((inputs?: Networks_List_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Networks_List_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_networks_list_description(inputs)
	return en_networks_list_description(inputs)
});